window.VITALEA_CONFIG = (() => {

    /*
    |--------------------------------------------------------------------------
    | AMBIENTE ACTIVO
    |--------------------------------------------------------------------------
    | Opciones:
    | local
    | development
    | production
    |--------------------------------------------------------------------------
    */

    const environment = 'production';

    /*
    |--------------------------------------------------------------------------
    | URLS
    |--------------------------------------------------------------------------
    */

    const environments = {

        local: {
            middlewareBaseUrl: 'http://localhost:8000/'
        },

        development: {
            middlewareBaseUrl: 'https://web-vitalea-2-desarrollo.azurewebsites.net/'
        },

        production: {
            middlewareBaseUrl: 'https://web-vitalea-2-pruebas.azurewebsites.net/'
        }

    };

    if (!environments[environment]) {
        console.error('[environment.js] Ambiente "' + environment + '" no existe. Usa: ' + Object.keys(environments).join(', '));
    }

    return {
        environment,
        ...environments[environment]
    };

})();

window.middlewareBaseUrl = window.VITALEA_CONFIG.middlewareBaseUrl;